var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightBulbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00065 13.5002C3.00065 13.8668 3.30065 14.1668 3.66732 14.1668H6.33398C6.70065 14.1668 7.00065 13.8668 7.00065 13.5002V12.8335H3.00065V13.5002ZM5.00065 0.833496C2.42732 0.833496 0.333984 2.92683 0.333984 5.50016C0.333984 7.08683 1.12732 8.48016 2.33398 9.32683V10.8335C2.33398 11.2002 2.63398 11.5002 3.00065 11.5002H7.00065C7.36732 11.5002 7.66732 11.2002 7.66732 10.8335V9.32683C8.87398 8.48016 9.66732 7.08683 9.66732 5.50016C9.66732 2.92683 7.57398 0.833496 5.00065 0.833496ZM6.90065 8.2335L6.33398 8.6335V10.1668H3.66732V8.6335L3.10065 8.2335C2.20065 7.60683 1.66732 6.58683 1.66732 5.50016C1.66732 3.66016 3.16065 2.16683 5.00065 2.16683C6.84065 2.16683 8.33398 3.66016 8.33398 5.50016C8.33398 6.58683 7.80065 7.60683 6.90065 8.2335Z",
    fill: "#8B98AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulbIcon);
export default __webpack_public_path__ + "static/media/LightBulbIcon.c7a5bee8.svg";
export { ForwardRef as ReactComponent };